import './App.css';

import React, { useEffect } from 'react';

import Navbar from './components/Navbar';

import UlotkaFront from './img/ulotka_front.jpg';
import UlotkaBack from './img/ulotka_back.jpg';

import Upowszechnianie_1 from './img/upowszechnianie/351098134_489347313365793_1468522159995429987_n.jpg';
import Upowszechnianie_2 from './img/upowszechnianie/351541604_540036778160076_323925016334987893_n.jpg';
import Upowszechnianie_3 from './img/upowszechnianie/351543792_1052790809435068_2411836059797046529_n.jpg';
import Upowszechnianie_4 from './img/upowszechnianie/351890038_950251952792359_82998329053146537_n.jpg';
// GAZETKA
import Upowszechnianie_5 from './img/gazetka/375578966_1079632816530481_2546675746745011352_n.jpg';
import Upowszechnianie_6 from './img/gazetka/375668723_663657349050773_8487244767553921922_n.jpg';
import Upowszechnianie_7 from './img/gazetka/375688632_691585432379931_5222850384139027301_n.jpg';
import Upowszechnianie_8 from './img/gazetka/375689833_616717967308078_2434483341203977702_n.jpg';
import Upowszechnianie_9 from './img/gazetka/375702366_1381951222440505_3585860497193511189_n.jpg';
import Upowszechnianie_10 from './img/gazetka/375754560_321302387066070_2344516813305635054_n.jpg';

import useMobile from './hooks/useMobile';

const Gazetka_z_Erasmusem_2023_ostateczna_po_polsku = process.env.PUBLIC_URL + '/pdf/Gazetka-z-Erasmusem-2023-ostateczna-po-polsku.pdf';

const contentHeight = '640px';
function Pdf(props: { src: string }) {
    return (
        <object data={props.src} type="application/pdf" width="100%" height={contentHeight}></object>
    )
}

function Gallery(props: { images: { src: string, alt: string }[] }) {
    return (
        <div className='Gallery'>
            {props.images.map((image) => {
                return (
                    <div className='Gallery__image'>
                        <a href={image.src} target='_blank'><img src={image.src} alt={image.alt} width={'100%'} /></a>
                    </div>
                )
            })}
        </div>
    )
}

function FacebookPost( props: { src: string } ) {
    return (
        <iframe src={props.src} width="100%" height="640" style={{border: 'none'}} allowFullScreen={true} allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    )
}

export default function Upowszechnianie() {
    useEffect(() => {
        window.scrollTo({top: 0});
    }, [])
    const ulotki_gallery = [
        {
            src: UlotkaFront,
            alt: 'Ulotka polska'
        },
        {
            src: UlotkaBack,
            alt: 'Ulotka angielska'
        },
    ]

    const gazetka = [
        {
            src: Upowszechnianie_5,
            alt: 'Gazetka 1'
        },
        {
            src: Upowszechnianie_9,
            alt: 'Gazetka 5'
        },
        {
            src: Upowszechnianie_7,
            alt: 'Gazetka 3'
        },
        {
            src: Upowszechnianie_6,
            alt: 'Gazetka 2'
        },
    ]

    const gazety_szkoly_gallery = [
        {
            src: Upowszechnianie_3,
            alt: 'Upowszechnianie 3'
        },
        {
            src: Upowszechnianie_2,
            alt: 'Upowszechnianie 2'
        },
        {
            src: Upowszechnianie_1,
            alt: 'Upowszechnianie 1'
        },
        {
            src: Upowszechnianie_4,
            alt: 'Upowszechnianie 4'
        },
    ]

    return (
        <>
        <Navbar />
        <div className='App__container'>
            <div className='App'>
                <div className='App__content'>
                    <div className='App__content__title'>
                        Upowszechnianie
                    </div>
                    <div className='Wycieczka__title'>
                        Promocja projektu w szkole i gazetach.
                    </div>
                    <Pdf src={Gazetka_z_Erasmusem_2023_ostateczna_po_polsku} />
                    <Gallery images={gazetka} />
                    <Gallery images={gazety_szkoly_gallery} />
                    <div className='Wycieczka__title'>
                        Ulotka informacyjna o projekcie w języku polskim i angielskim.
                    </div>
                    <Gallery images={ulotki_gallery} />
                    <div className='Wycieczka__title'>
                        Posty promujące projekt.
                    </div>
                    <FacebookPost src='https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid0YMQgArm971qoKqzVDo8rJBquRQHdjEzrdrksXmgWyHyzaFP6wyQK5jdiu2usht3dl%26id%3D100063617561192&show_text=true&width=auto' />
                    <FacebookPost src='https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid0iKZqJYgv3wAbFRqftGgdhuEadqaSSskKLq6vVNCJCUDW2q7Vzjp9UA8cAu5LVRVGl%26id%3D100063617561192&show_text=true&width=auto' />
                </div>
            </div>
            <div className='App__background'></div>
        </div>
        </>
    )
}